import { useRef } from "react";
import VideoCard from "@/components/base/VideoCard";
import { getFeaturedVideos } from "@/utils/video";

export default function HotRow() {
  const scroller = useRef<HTMLDivElement>(null);
  const items = getFeaturedVideos(8);

  const scrollBy = (dir: number) => {
    scroller.current?.scrollBy({ left: dir * 300, behavior: "smooth" });
  };

  return (
    <div className="relative">
      <div className="hidden md:flex absolute -top-12 right-0 items-center gap-2">
        <button
          type="button"
          onClick={() => scrollBy(-1)}
          aria-label="向左滚动"
          className="flex items-center justify-center w-9 h-9 rounded-full border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600 cursor-pointer transition-colors"
        >
          <i className="ri-arrow-left-s-line text-lg" />
        </button>
        <button
          type="button"
          onClick={() => scrollBy(1)}
          aria-label="向右滚动"
          className="flex items-center justify-center w-9 h-9 rounded-full border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600 cursor-pointer transition-colors"
        >
          <i className="ri-arrow-right-s-line text-lg" />
        </button>
      </div>

      <div
        ref={scroller}
        className="flex gap-4 md:gap-5 overflow-x-auto no-scrollbar -mx-4 px-4 md:mx-0 md:px-0 pb-1"
      >
        {items.map((v, i) => (
          <div key={v.id} className="w-[200px] sm:w-[220px] md:w-[248px] shrink-0">
            <VideoCard video={v} index={i} />
          </div>
        ))}
      </div>
    </div>
  );
}